import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  return (
    <main className="min-h-[70vh] flex items-center justify-center px-4 py-16 bg-splash-cream">
      <div className="max-w-lg w-full bg-white rounded-3xl border border-splash-sand shadow-sm p-8 text-center" data-testid="payment-cancel-page">
        <XCircle className="w-12 h-12 text-splash-coral mx-auto mb-3" />
        <h1 className="font-display font-bold text-3xl text-splash-green">Payment cancelled</h1>
        <p className="mt-2 text-splash-green/80">No charge was made. Your spot isn't held yet — return any time to complete enrollment.</p>
        <div className="mt-6 flex items-center justify-center gap-2">
          <Link to="/" className="rounded-full bg-white border border-splash-sand text-splash-green px-5 py-2.5 text-sm font-semibold btn-transition hover:bg-splash-cream">Home</Link>
          <Link to="/programs" className="rounded-full bg-splash-coral hover:bg-splash-coralDark text-white px-5 py-2.5 text-sm font-semibold btn-transition">See programs</Link>
        </div>
      </div>
    </main>
  );
}
